
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.268 1.732l.53-.53-.53.53zM4.5 19.035v.75a.75.75 0 00.53-.22l-.53-.53zm-3.5 0H.25c0 .415.336.75.75.75v-.75zm0-3.57l-.53-.53a.75.75 0 00-.22.53H1zM13.762 2.701a.75.75 0 00-1.06 1.06l1.06-1.06zm2.475 4.596a.75.75 0 101.061-1.06l-1.06 1.06zm-.974-5.035a1.75 1.75 0 012.474 0l1.061-1.061a3.25 3.25 0 00-4.596 0l1.06 1.06zm2.474 0a1.75 1.75 0 010 2.474l1.061 1.061a3.25 3.25 0 000-4.596l-1.06 1.06zm0 2.474L3.97 18.505l1.06 1.06L18.798 5.799l-1.06-1.06zM4.5 18.286H1v1.5h3.5v-1.5zm9.702-17.084L.47 14.934l1.06 1.06L15.262 2.264l-1.06-1.061zM.25 15.464v3.571h1.5v-3.57H.25zM12.702 3.763l3.535 3.535 1.061-1.06-3.535-3.536-1.061 1.06z"}})])
          )
        }
      }
    